import { Box, Flex, Grid, GridItem, Image, Input, InputGroup, InputLeftElement, Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from "@chakra-ui/react";
import MyDiv from "./shift.style";
import { ChevronDownIcon, Search2Icon } from "@chakra-ui/icons";
import { AlertCard, CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IShift, IBusinessProcessDropdown } from "./model";
import { useFetch } from "../../../../hooks/useFetch";
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
  { id: 1, head: "S. No" },
  { id: 2, head: "Shift" },
  { id: 3, head: "Business Process" },
  { id: 4, head: "Status" },
  { id: 5, head: "Actions" },
];

const Shift = () => {
  const [shifts, setShifts] = useState<IShift[]>([]);
  const [businessProcessDropdown, setBusinessProcessDropdown] = useState<IBusinessProcessDropdown[]>([]);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentShift, setCurrentShift] = useState({
    id: 0,
    shift: "",
    business_Process_Id: 0,
    status: true,
  });

  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [statusChangeSource, setStatusChangeSource] = useState<"table" | "drawer" | null>(null);

  useEffect(() => {
    loadShift();
    loadBusinessProcessDropDown();
  }, []);

  const loadShift = async () => {
    const response = await fetchApi<IShift[]>("Hrlense_Shift", "GET");
    if (response) setShifts(response);
  };

  const loadBusinessProcessDropDown = async () => {
    const response = await fetchApi<IBusinessProcessDropdown[]>("Dropdown/businessProcess", "GET");
    if (response) setBusinessProcessDropdown(response);
  };

  const handleStatusChange = (id: number, newStatus: boolean) => {
    setSelectedId(id);
    setPendingStatus(newStatus);
    setStatusChangeSource("table");
    setAlertOpen(true);
  };

  const handleDrawerStatusChange = (newStatus: boolean) => {
    setPendingStatus(newStatus);
    setStatusChangeSource("drawer");
    setAlertOpen(true);
  };

  const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const shiftId = statusChangeSource === "table" ? selectedId : currentShift.id;

      const response = await fetchApi(`Hrlense_Shift/toggleStatus/${shiftId}`,"PUT",{ id: shiftId, status: pendingStatus }
      );

      if (response) {
        if (statusChangeSource === "table") {
          setShifts((prev) =>
            prev.map((shifts) =>
              shifts.id === selectedId ? { ...shifts, status: pendingStatus } : shifts
            )
          );
        } else {
          setCurrentShift((prev) => ({ ...prev, status: pendingStatus }));
        }
      }
    }
    setAlertOpen(false);
  };

  const handleAddNewShift = () => {
    setIsEditMode(false);
    setCurrentShift({
      id: 0,
      shift: "",
      business_Process_Id: 0,
      status: true,
    });
    setDrawerOpen(true);
  };

  const handleEditShift = (shift: IShift) => {
    setIsEditMode(true);
    setSelectedId(shift.id);
    setCurrentShift({
      id: shift.id,
      shift: shift.shift,
      business_Process_Id: shift.business_Process_Id,
      status: shift.status,
    });
    setDrawerOpen(true);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setCurrentShift((prev) => ({
      ...prev,
      [name]: name === "business_Process_Id" ? Number(value) : value,
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      id: currentShift.id,
      shift: currentShift.shift,
      business_Process_Id: currentShift.business_Process_Id,
      status: currentShift.status,
    };

    if (isEditMode) {
      const response = await fetchApi(`Hrlense_Shift/${currentShift.id}`, "PUT", payload, null, "Shift updated successfully");
      if (response) await loadShift();  
    } else {
      const response = await fetchApi<IShift>( "Hrlense_Shift", "POST", payload, null, "Shift added successfully"
      );
      if (response) setShifts((prev) => [...prev, response]);
    }
    setDrawerOpen(false);
  };

  const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
          </Center>
        ) : (
          <>
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_semibold text_3xl">Shift List</Text>
              <Flex gap={2}>
                <InputGroup width="197px" height="37px">
                  <InputLeftElement pointerEvents="none">
                    <Search2Icon color="rgba(102, 112, 133, 1)" />
                  </InputLeftElement>
                  <Input
                    type="text"
                    className="font-poppins text_regular text_md"
                    placeholder="Search by Shift...."
                    maxW="500px"
                  />
                </InputGroup>
                <CustomButton
                  title="Add New Shift"
                  className=" btn font-poppins text_sm text_medium"
                  rightIcon={<Image src={PlusIcon} className="logo" />}
                  onClick={handleAddNewShift}
                />
              </Flex>
            </Flex>
            <Grid className="grid_container">
              <GridItem colSpan={12}>
                <CustomTable value={shifts} >
                  <Column header="S. No" body={(_, index) => index + 1} />
                  <Column header="Shift" field="shift" />
                  <Column header="Business Process" field="business_Process_Name" />
                
                  <Column<any>
                    header="Status"
                    body={(row: any) => (
                      <Select
                        value={row.status ? "true" : "false"}
                        onChange={(e) => handleStatusChange(row.id, e.target.value === "true")}
                        width="120px"
                        height="32px"
                        icon={<ChevronDownIcon />}
                        borderRadius="4px"
                        color={getStatusColor(row.status)}
                        className="font-poppins text_medium text_xsm"
                      >
                        <option value="true" style={{ color: "#38A169" }}>Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    )}
                  />
                
                  <Column
                    header="Actions"
                    body={(row: any) => <ActionEditIcon onClick={() => handleEditShift(row)} />}
                  />
                </CustomTable>

              </GridItem>
            </Grid>
            <AlertCard
              isOpen={AlertOpen}
              onClose={() => setAlertOpen(false)}
              onConfirm={handleConfirmStatusChange}
            />
            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px">
                  {isEditMode ? "Edit Shift" : "Add New Shift"}
                </DrawerHeader>
                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                  <Box py={4}>
                    <FormControl mb={4}>
                      <FormLabel>Shift</FormLabel>
                      <Input
                        name="shift"
                        value={currentShift.shift}
                        onChange={handleInputChange}
                        placeholder="Enter Shift Time"
                      />
                    </FormControl>
                    <FormControl mb={4}>
                      <FormLabel>Business Process</FormLabel>
                      <Select
                        name="business_Process_Id"
                        value={currentShift.business_Process_Id}
                        onChange={handleInputChange}
                        placeholder="Select Business Process"
                      >
                        {businessProcessDropdown.map((bp) => (
                          <option key={bp.business_Process_Id} value={bp.business_Process_Id}>
                            {bp.business_Process_Name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl mb={4}>
                      <FormLabel>Status</FormLabel>
                      <Select
                        w="120px"
                        value={currentShift.status ? "true" : "false"}
                        onChange={(e) => handleDrawerStatusChange(e.target.value === "true")}
                        color={getStatusColor(currentShift.status)}
                      >
                        <option value="true" style={{ color: "#38A169" }}>Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Flex justify="flex-end" mt={4} gap={2}>
                    <Button
                      className="font-poppins text_sm text_medium"
                      onClick={() => setDrawerOpen(false)}
                      style={{ backgroundColor: "#D92F34", color: "white" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      className="font-poppins text_sm text_medium"
                      style={{ backgroundColor: "#006838", color: "white" }}
                    >
                      {isEditMode ? "Update Shift" : "Add Shift"}
                    </Button>
                  </Flex>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </>
        )}
      </Box>
    </MyDiv>
  );
};

export default Shift;